import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/yacht-engines', data)
    .then(response => {
      return response.data
    })
}

function update(data, id) {
  return axios.patch(`/yacht-engines/${id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  fetch(params) {
    return axios.get('/yacht-engines', { params: params })
      .then(response => {
        return response.data
      })
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  destroy(id) {
    return axios.delete(`/yacht-engines/${id}`)
  }
}
